/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { htmlspecialchars } from './util.js';
import { mjt } from './i18ntexts.js';
import { MDLocale } from './locale-impl.js';
import { $ } from '../other/jquery-hooked.js';


var traceElementsDefs = null;

function _fillTraceElementsDefs() {
	traceElementsDefs = {
		minerals: {
			title: mjt('meta-def-obj-tei-section-minerals','!'),
			defs: {
				Kalium_mg:			{ unit: 'mg',		title: mjt('meta-def-obj-tei-mineral-Kalium','!') },
				Chlor_mg:			{ unit: 'mg',		title: mjt('meta-def-obj-tei-mineral-Chlor','!') },
				Calcium_mg:			{ unit: 'mg',		title: mjt('meta-def-obj-tei-mineral-Calcium','!') },
				Phosphor_mg:		{ unit: 'mg',		title: mjt('meta-def-obj-tei-mineral-Phosphor','!') },
				Magnesium_mg:		{ unit: 'mg',		title: mjt('meta-def-obj-tei-mineral-Magnesium','!') },
				Eisen_mg:			{ unit: 'mg',		title: mjt('meta-def-obj-tei-mineral-Eisen','!') },
				Zink_mg:			{ unit: 'mg',		title: mjt('meta-def-obj-tei-mineral-Zink','!') },
				Kupfer_mg:			{ unit: 'mg',		title: mjt('meta-def-obj-tei-mineral-Kupfer','!') },
				Mangan_mg:			{ unit: 'mg',		title: mjt('meta-def-obj-tei-mineral-Mangan','!') },
				Flour_mg:			{ unit: 'mg',		title: mjt('meta-def-obj-tei-mineral-Flour','!') },

				Selen_µg:			{ unit: 'µg',		title: mjt('meta-def-obj-tei-mineral-Selen','!') },
				Chrom_µg:			{ unit: 'µg',		title: mjt('meta-def-obj-tei-mineral-Chrom','!') },
				Molybdaen_µg:		{ unit: 'µg',		title: mjt('meta-def-obj-tei-mineral-Molybdaen','!') },
				Jod_µg:				{ unit: 'µg',		title: mjt('meta-def-obj-tei-mineral-Jod','!') },
			}
		},
		vitamins: {
			title: mjt('meta-def-obj-tei-section-vitamins','!'),
			defs: {
				A_µg:				{ unit: 'µg',		title: mjt('meta-def-obj-tei-vitamin-A','!') },
				D_µg:				{ unit: 'µg',		title: mjt('meta-def-obj-tei-vitamin-D','!') },
				E_mg:				{ unit: 'mg',		title: mjt('meta-def-obj-tei-vitamin-E','!') },
				K_µg:				{ unit: 'µg',		title: mjt('meta-def-obj-tei-vitamin-K','!') },
				C_mg:				{ unit: 'mg',		title: mjt('meta-def-obj-tei-vitamin-C','!') },

				Thiamin_mg:			{ unit: 'mg',		title: mjt('meta-def-obj-tei-vitamin-Thiamin','!') },		// B1
				Riboflavin_mg:		{ unit: 'mg',		title: mjt('meta-def-obj-tei-vitamin-Riboflavin','!') },		// B2
				Niacin_mg:			{ unit: 'mg',		title: mjt('meta-def-obj-tei-vitamin-Niacin','!') },

				B6_mg:				{ unit: 'mg',		title: mjt('meta-def-obj-tei-vitamin-B6','!') },
				Folsaeure_µg:		{ unit: 'µg',		title: mjt('meta-def-obj-tei-vitamin-Folsaeure','!') },
				B12_µg:				{ unit: 'µg',		title: mjt('meta-def-obj-tei-vitamin-B12','!') },

				Biotin_µg:			{ unit: 'µg',		title: mjt('meta-def-obj-tei-vitamin-Biotin','!') },
				Pantothensaeure_mg:	{ unit: 'mg',		title: mjt('meta-def-obj-tei-vitamin-Pantothensaeure','!') },
			}
		}
	};
}


// eslint-disable-next-line import/no-unused-modules
export function renderTraceElementsTableAsText( table, hideEmptyRows ) {
	let lines = [];
	if(!traceElementsDefs) _fillTraceElementsDefs();
	for( const [sectionName,sectionDef] of Object.entries(traceElementsDefs) ) {

		let line = sectionName||'';
		lines.push(line);

		for( const [name,def] of Object.entries(sectionDef.defs) ) {
			const info = table[name] ?? { };
			const value = info.value || '';
			if( hideEmptyRows ) {
				if( value==='' ) continue;
			}
			let line = name||'';
			line += ': ' + value + ' ' + def.unit;
			// if( info.hasOwnProperty('pct_gda') ) {
			line += ' (' + info.pct_gda + '%)';
			// }
			lines.push(line);
		}
	}
	return lines.join('\n');
}


// eslint-disable-next-line import/no-unused-modules
export function renderTraceElementsTableAsHTML( table, hideEmptyRows ) {
	let rows = [];
	if(!traceElementsDefs) _fillTraceElementsDefs();
	for( const [sectionName,sectionDef] of Object.entries(traceElementsDefs) ) {

		let row = '<span class="trace-elements-table-section-row">';
		row += '<span class="nt-section-name">'+htmlspecialchars(sectionDef.title||sectionName||'')+'</span>';
		row += '</span>';
		rows.push(row);

		for( const [name,def] of Object.entries(sectionDef.defs) ) {
			const info = table[name] ?? { };
			const value = info.value || '';
			if( hideEmptyRows ) {
				if( value==='' ) continue;
			}
			let row = '<span class="trace-elements-table-row">';
			const xClassName = (def.par??'')==='' ? '' : ' indented';
			row += '<span class="nt-name'+xClassName+'">'+htmlspecialchars(def.title||name||'')+'</span>';


			const valueStr = MDLocale.fmt_number_input(value);
			row += '<span class="nt-value">'+htmlspecialchars(valueStr)+'</span>';
			row += '<span class="nt-unit">'+htmlspecialchars(def.unit||'')+'</span>';


			const pctGda = info.pct_gda || '';
			const pctGdaStr = MDLocale.fmt_number_input(pctGda);
			row += '<span class="nt-pct_gda">'+htmlspecialchars(pctGdaStr)+' % </span>';


			row += '</span>';
			rows.push(row);
		}
	}
	return '<span class="trace-elements-table">'
				+rows.join('\n')
			+'</span>';
}


// eslint-disable-next-line import/no-unused-modules
export function renderTraceElementsTableInputWidget( wdgs_div, table ) {
	if(!traceElementsDefs) _fillTraceElementsDefs();
	for( const [sectionName,sectionDef] of Object.entries(traceElementsDefs) ) {

		const rowDiv = document.createElement('div');
		rowDiv.className = 'ni-section-row';

		const nameLabel = document.createElement('label');
		nameLabel.textContent = sectionDef.title||sectionName||'';
		rowDiv.appendChild(nameLabel);

		wdgs_div.append(rowDiv);


		for( const [name,def] of Object.entries(sectionDef.defs) ) {
			const info = table[name] ?? { };
			const value = info.value || '';

			const rowDiv = document.createElement('div');
			rowDiv.className = 'ni-field-row ni-field-row-'+name;

			const nameLabel = document.createElement('label');
			if( (def.par??'')!=='' ) {
				nameLabel.className = 'indented';
			}
			nameLabel.textContent = def.title||name||'';
			rowDiv.appendChild(nameLabel);


			const valSpan = document.createElement('span');
			valSpan.className = 'ni-field-value';

			$(valSpan).mjWidget( {
				type: 'special-float',
				name: name+'.value',
				no_negative_values: true,
				accepted_prefixes: '<',
				preserve_significance: true,
				'default': value,
				unit_label: def.unit,
				addClass: 'ni-value w50',
				unit_label_addClass: 'ni-value-unit',
			} );

			rowDiv.appendChild(valSpan);
			nameLabel.htmlFor = $(valSpan).mjWidget('id');


			const pctGda = info.pct_gda || '';

			const pctGdaSpan = document.createElement('span');
			pctGdaSpan.className = 'ni-field-pct_gda';

			$(pctGdaSpan).mjWidget( {
				type: 'special-float',
				name: name+'.pct_gda',
				no_negative_values: true,
				accepted_prefixes: '<',
				preserve_significance: true,
				'default': pctGda,
				unit_label: '%',
				addClass: 'ni-value w30',
				unit_label_addClass: 'ni-pct_gda-unit',
			} );

			rowDiv.appendChild(pctGdaSpan);


			wdgs_div.append(rowDiv);
		}
	}
}


// eslint-disable-next-line import/no-unused-modules
export function getTraceElementsTableDataFromInputWidget( wdgs_div ) {
	const $form = wdgs_div.closest('form');
	let table = {};

	$form.find('.ni-field-value,.ni-field-pct_gda').each( function() {
		const $this = $(this);
		const value = $this.mjWidget('get');

		const key = $this.mjWidget('name');
		const [name,prop] = key.split('.');

		if( table.hasOwnProperty(name) ) table[name][prop] = value;
		else table[name] = { [prop]: value };
	} );

	return table;
}


